export default __webpack_public_path__ + "static/media/Confirmed.7bfc8c3c.svg";